<template>
  <div class="modal-add-course">
      <div v-if="showModal">
          <transition name="modal">
              <div class="modal-mask">
                  <div class="modal-wrapper">
                  <div class="modal-dialog" role="document">
                      <div class="modal-content">
                          <div class="modal-header">
                              <h5 class="modal-title">Subir Archivo CSV</h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true" @click="toggleModal()">&times;</span>
                              </button>
                          </div>
                          <div class="modal-body">
                            <!--UPLOAD-->
                            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
                              <div class="dropbox">
                                <input type="file" :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event);"
                                  accept=".csv" class="input-file">
                                  <p v-if="isInitial">
                                    Drag your file(s) here to begin<br> or click to browse
                                  </p>
                              </div>
                            </form>
                          </div>
                      </div>
                  </div>
                  </div>
              </div>
          </transition>
      </div>
  </div>
</template>

<script>
import firebase from "firebase/app"
import 'firebase/firestore'
import 'firebase/storage'
import { es } from "vuejs-datepicker/src/locale"
import * as CSV from 'csv-string';
const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

export default {
  name: "ModalUploadCSV",
  created() {
    this.getCourses()
  },
  computed: {
      showModal() {
        return this.$store.getters.addCVSShow
      },
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      },
      courses() {
        return this.$store.getters.activeCourses
      },
  },
  watch: {
  },
  data() {
    return {
      actionBtn: "add",
      es: es,
      inputClass: "form-control",

      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'files'

    }
  },
  methods: {
    async getCourses() {
      try {
        await this.$store.dispatch('getCourses')
      } catch (error) {
        console.log('Error al obtener cursos')
      }
    },
    toggleModal() {
      this.actionBtn = "add"
      this.$store.dispatch("toggleModalUploadCSV")
    },

    ////////////
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    filesChange(event) {
      //console.log(event)
      const reader = new FileReader()
      reader.onload = this.handleFileLoad;
      reader.readAsText(event.target.files[0]);
    },
    async handleFileLoad(event){
      this.$toasted.show('Este proceso puede tomar tiempo, por favor espere.');
      let currentCourse = this.$store.getters.currenCourse;
      let courseData = this.courses.find(doc => doc.id === currentCourse)
      let content_file = event.target.result
      let listEmails = []
      let existsEmail = 0
      CSV.forEach(content_file, ',', async function(row, index) {
        if (index != 0 && row != "") {
          if (!listEmails.includes(row[2])) {
            listEmails.push(row[2])
            let infoUser = {
              name: row[0],
              lastname: row[1],
              course: courseData.name,
              galileoCode: row[3],
              issued: new Date(),
              email: row[2],
              achievement: row[4],
              status: 0,
              createdAt: new Date(),
              isSigned: false
            }
            let userExists = await this.$store.getters.existsEmail(courseData.id, row[2]);
            if (userExists == 0) {
              await firebase.firestore().collection("entities").doc(courseData.id).collection("certificates").add(infoUser)
            } else {

              existsEmail = 1;
              this.$toasted.show(`El correo "${row[2]}" ya se encuentra en los registros.`, {type: "error", duration : null,})
            }
          } else {
            this.$toasted.show(`El correo "${row[2]}" se encuentra duplicado dentro del documento.`, {type: "error", duration : null,})
            existsEmail = 1;
          }
        }
      }.bind(this));
      this.toggleModal()
      this.$store.commit("setCertificateSaved", { courseId: courseData.id })
      this.$store.commit("cleanCertificate")
      //this.$store.dispatch("toggleModalUploadCSV")
      if (existsEmail == 1) {
        //this.$toasted.show('Algunos datos ya existen.', {type: "error"})
      } else {
        this.$toasted.show('Datos ingresados con éxito');
      }
    }
  },
  mounted() {
    this.reset();
  },
  components: {
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  -webkit-transition: opacity 500ms ease-in;
  -moz-transition: opacity 500ms ease-in;
  transition: opacity 500ms ease-in;
  overflow: auto;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-header {
  background-color: #007bff;
  color: #fefefe;
}
.modal-header span {
  color: #fefefe;
}
.form-group {
  margin-bottom: 0 !important;
}

.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ModalUploadCSV.vue